export default __webpack_public_path__ + "static/media/sunset-sea.ed963469.jpeg";